<button mat-raised-button [disabled]="disabled" class="primary" (click)="delete();" type="button"><mat-icon>save</mat-icon> {{label}}</button>
